"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStickyHeader = exports.StickyHeaderProvider = exports.DEFAULT_STICKY_HEIGHT = void 0;
var _react = _interopRequireWildcard(require("react"));
var _debounce = require("b2b-components/utils/debounce");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const StickyHeaderContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const DEFAULT_STICKY_HEIGHT = exports.DEFAULT_STICKY_HEIGHT = 144;
const SCROLL_DEBOUNCE_DELAY = 100;
const StickyHeaderProvider = _ref => {
  let {
    children,
    isMobile
  } = _ref;
  const headerElementRef = (0, _react.useRef)(null);
  const prevScrollY = (0, _react.useRef)(0);
  const [isDisabled, setIsDisabled] = (0, _react.useState)(isMobile);
  const bottom = isDisabled ? 0 : headerElementRef.current?.clientHeight || DEFAULT_STICKY_HEIGHT;
  const handleScroll = (0, _debounce.debounce)(() => {
    setIsDisabled(prevScrollY.current > window?.scrollY);
    prevScrollY.current = window?.scrollY;
  }, SCROLL_DEBOUNCE_DELAY);
  (0, _react.useEffect)(() => {
    if (isMobile) {
      window?.addEventListener('scroll', handleScroll);
    }
    return () => {
      window?.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(StickyHeaderContext.Provider, {
    value: {
      ref: headerElementRef,
      bottom,
      isDisabled: !!isDisabled
    }
  }, children);
};
exports.StickyHeaderProvider = StickyHeaderProvider;
const useStickyHeader = () => {
  const context = (0, _react.useContext)(StickyHeaderContext);
  if (context === undefined) {
    return null;
  }
  return context;
};
exports.useStickyHeader = useStickyHeader;
//# sourceMappingURL=StickyHeaderContext.js.map